import styled from 'react-emotion';
import { themeGet } from 'styled-system';
import { NavToggleBar } from '../toggle';
import { FlexCol, FlexRowBetween } from '../misc';

// @flex
export const MenuWrapper = styled(FlexCol)`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const MenuListWrapper = styled(FlexCol)`
  height: 100%;
  margin: 16px 0 32px 0;
`;

export const DataImprintWrapper = styled(FlexRowBetween)`
  border-top: 1px solid rgba(218, 225, 231, 1);
  padding: ${themeGet('space.4')}px 0;
`;
// @flex
export const MenuHeader = styled('header')`
  background-color: ${themeGet('colors.red')};
  color: ${themeGet('colors.white')};
  flex: 0 0 120px;
  display: flex;
  align-items: flex-end;

  > div {
    position: absolute;
    top: 0;
    right: 0;

    > ${NavToggleBar}::before, > ${NavToggleBar}::after {
      background-color: white;
    }
  }
`;

// @padding
// TODO: define heading style
export const MenuTitle = styled('h2')`
  color: white;
  font-weight: 500;
  padding: ${themeGet('space.3')}px;
`;

export const MenuList = styled('ul')`
  margin-top: 8px;
`;

// @padding
export const MenuListItem = styled('li')`
  border-bottom: 1px solid ${themeGet('colors.greyLight')};
  padding: ${themeGet('space.3')}px ${themeGet('space.3')}px;
  cursor: pointer;
  transition: all 0.15s ease-in;
  color: ${themeGet('colors.black')};

  @media screen and (min-width: 40rem) {
    padding: ${themeGet('space.4')}px ${themeGet('space.4')}px;
  }

  &:hover {
    background-color: ${themeGet('colors.greyLight')};
  }

  span {
    margin-left: 16px;
    font-weight: 300;
    font-size: 16px;
    font-weight: 300;

    @media screen and (min-width: 40rem) {
      font-size: 18px;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/nav/style.js